import { render } from "./EditProfile.vue?vue&type=template&id=5eb0babf"
import script from "./EditProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./EditProfile.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/EditProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5eb0babf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5eb0babf', __exports__)) {
    api.reload('5eb0babf', __exports__)
  }
  
  module.hot.accept("./EditProfile.vue?vue&type=template&id=5eb0babf", () => {
    api.rerender('5eb0babf', render)
  })

}


export default __exports__